
<template>
   <div>
       <Breadcrumbs main="Attributes" title="Attributes Details" />

      <div class="container-fluid">
         <div class="row">
            <div class="col-sm-12">
               <div class="card">
                  <div class="card-body">

                     <div class="col-md-12 project-list  page-subtitle">
                        <div class="row">
                           <div class="col-md-10 d-flex">
                              <span style="font-size: 25px; font-weight: bolder;">Attributes Details</span>
                           </div>
                           <div class="col-md-2 d-flex">
                              <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='fa fa-chevron-left'></i> Back</a>
                           </div>
                           <div class="col" style="margin-top: 15px;">
                              <!-- <router-link :to="{ name: 'users.adduser' }" class="btn btn-primary">Add User</router-link> -->
                              <div class="row">
                                 <div class="col-sm-6">
                                    <div class="col-md-6">
                                       <label class="control-label">Attribute <span class="required" v-if="!disabled">*</span></label><br>
                                       <input v-model="attribute.name" class="form-control" v-bind:class="{ 'is-invalid': Boolean(attribute_errors.name) }" :disabled="disabled"/>
                                       <div v-for="(val, index) in attribute_errors.name" :key="index" class="invalid-feedback"> 
                                          <p class="mb-0">{{val}}</p>
                                       </div> 
                                       
                                    </div>
                                 </div>
                              </div> 

                              <div class="row">
                                 <div class="col-sm-12 d-flex">
                                    <div class="d-flex">
                                       <a v-if="disabled" class="btn btn-primary me-2" @click="disabled = false">Edit</a>
                                       <a type="submit" v-if="!disabled" class="btn btn-primary me-2"  @click="updateAttribute">Update</a>
                                       <a v-if="!disabled" class="btn btn-primary me-2" @click="resetAttribute">Cancel</a>
                                    </div>

                                    <div v-if="disabled" class="d-flex">
                                       <a class="btn btn-danger me-1" @click="deactivateAttribute()" v-if="attribute.status==1">Deactivate</a>
                                       <a class="btn btn-success me-1" @click="activateAttribute()" v-else>Activate</a>
                                    </div>
                                 </div>
                              </div>
                           </div>                           
                        </div>
                     </div>
                     </div>
                  </div>

                  <div class="card">
                     <div class="card-body">   
                     <div class="col-md-12 project-list">
                        <div class="row">
                           
                           <div class="col-md-12 float-end">
                              <button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Value</button>
                           </div> 
                        </div>
                     </div>

                     <div class="table-responsive product-table">
                        <table class="display" id="basic-1">
                           <thead>
                              <tr>
                                 <th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-sort="ascending" aria-label="Name: activate to sort column descending"
                                    style="width: 415.266px;">Value</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Status: activate to sort column ascending"
                                    style="width: 337.797px;">Status</th>
                                 <th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
                                    aria-label="Options: activate to sort column ascending"
                                    style="width: 415.266px;">Options</th>	
                              </tr>
                           </thead>
                           <tbody>
                              <tr v-for="value in attribute.values" :key="value.id">
                                 
                                 <td>{{value.value}}</td>
                                 <td>
                                    <label v-if="value.status==1">Active</label>
                                    <label v-else>Blocked</label>
                                 </td>
                                 <td>
                                    

                                    <a class="btn btn-danger btn-sm mt-2 me-1" @click="deactivateValue(value)" v-if="value.status==1">Deactivate</a>
                                    <a class="btn btn-success btn-sm mt-2 me-1" @click="activateValue(value)" v-else>Activate</a>
                                    <a class="btn btn-primary btn-sm mt-2 me-1" @click="editValue(value)">Edit</a>
                                    <a class="btn btn-danger btn-sm mt-2 me-1" @click="deleteValue(value.id)">Delete</a>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>

                  </div>
               </div>
            </div>
         </div>
      </div>

      <DynamicModal :title="modal_title">
			<template #body>
				<form @submit.prevent="addValue" enctype="multipart/form-data" @hidden="clearForm()">
					<div class="col-md-12 form-group">
						<label class="control-label">Value <span class="required">*</span></label>
						<input class="form-control" type="text" placeholder="" v-model="value.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
						<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

  </div>
</template>


<script>
import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

export default {
   name:'AttributeDetails',
   components: {
			DynamicModal
		},

		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

   data() {
      return {
         attribute: {},
         value: {
            id: null,
            name: "",            
         },         
         modal_title: 'Add Value',
         button_title: 'Add',
         edit: false,
         disabled: true,
         attribute_status: {
            id: "",
            status: ""
         },
         value_status: {
            id: "",
            status: ""
         },
         
         token: '',
         attribute_errors: {},
         errors: {},
         delete: false,
         activate: false,
         deactivate: false,
      };
   },
   mounted () {
      
   },

   created() {
      this.fetchAttribute();
   },

   methods: {
      
      fetchAttribute() {
          let url = '/api/admin/attributes/show?attribute_id=' + this.$route.params.id ;
            
         this.getToken();
         this.$axios
            .get(url, {headers: {Authorization: 'Bearer ' + this.token,}})
            .then(res => {
               var responseData = res.data.data;               
               this.attribute = responseData; 
               console.log(this.attribute);             
            })
            .catch(err => console.log(err));
      },   

      openModal() {
			this.showModal();
		},

		closeModal() {
			this.hideModal();
		},

      getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },


      resetAttribute() {         
         this.fetchAttribute();
         this.disabled = true;
         this.attribute_errors = {};
      },

      updateAttribute() {
         this.getToken();
         this.errors = {};
         let url = '/api/admin/attributes/edit';
         let formData = new FormData();  
         formData.append('attribute_id', this.attribute.id);
         formData.append('name', this.attribute.name);
         
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };

         this.$axios
         .post(url, formData, config)
         .then(response => {
            if(response.data.status) {
               this.$swal("", response.data.message, "success");
				} else {
					this.$swal("", response.data.message, "error");
				}
            this.disabled = true;
            this.fetchAttribute();
            this.attribute_errors = {};
         })
         .catch(error => {
             
            if(error.response){
               if(error.response.data.message){
                  this.attribute_errors = error.response.data.message;
                  console.log(this.errors);
                  this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				} else {
					this.$swal("", "Something went wrong", "error");
				}       
         });          
      },

      activateAttribute() {
         this.activate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this attribute?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.attribute_status.id = this.attribute.id;
                  this.attribute_status.status = '1';
                  this.updateAttributeStatus();
					}
					
				});
      },
      deactivateAttribute() {
         this.deactivate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this attribute?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.attribute_status.id = this.attribute.id;
                  this.attribute_status.status = '0';
                  this.updateAttributeStatus();
					}
				});
      },
      updateAttributeStatus() {
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .get('/api/admin/attributes/status?attribute_id=' + this.attribute_status.id + '&status=' + this.attribute_status.status, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchAttribute();
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                        this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      },

      addValue(){
         this.getToken();  
         let formData = new FormData();  
         formData.append('name', this.value.name);
         
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         let url;
         if(!this.edit) {
            url = '/api/admin/attributes/add_value';
            formData.append('attribute_id', this.attribute.id);
         } else {
            url = '/api/admin/attributes/edit_value';            
            formData.append('value_id', this.value.id);
         }
            this.$axios
            .post(url, formData, config)
            .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
               this.clearForm();
               this.closeModal();
               this.fetchAttribute();
            })
            .catch(error => {
               
                  if(error.response){
                     if(error.response.data.message){
                        this.errors = error.response.data.message;
                        console.log(this.errors);
                        this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}       
            });               
       },

      editValue(value) {
         this.edit = true;
         this.value.id = value.id; 
         this.value.name = value.value;         
         this.errors = {};
         this.modal_title = 'Edit Value';
         this.button_title = 'Update';
         this.showModal();
      },
      clearForm() {
         this.edit = false;
         this.value.id = null;
         this.value.name = '';         
         this.modal_title = 'Add Value';
         this.button_title = 'Add';
         this.disabled = true;
         this.errors = {};
      },
      activateValue(attr_value) {
         this.activate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this attribute value?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.value_status.id = attr_value.id;
                  this.value_status.status = '1';
                  this.updateValueStatus();
					}
					
				});
      },
      deactivateValue(attr_value) {
         this.deactivate = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this attribute value?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.value_status.id = attr_value.id;
                  this.value_status.status = '0';
                  this.updateValueStatus();
					}
				});
      },
      updateValueStatus() {
         this.getToken();
         const config = {
              headers: {
                  'Authorization': 'Bearer ' + this.token,
              }
         };
         this.$axios
         .get('/api/admin/attributes/status_value?value_id=' + this.value_status.id + '&status=' + this.value_status.status, config)
         .then(response => {
               if(response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.fetchAttribute();
          })
          .catch(error => {
               if(error.response){
                  if(error.response.data.message){
                     this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
               
          });
      },

      deleteValue(value_id) {
         this.delete = false;
         this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this attribute?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
                     this.getToken();
                     const config = {
                        headers: {
                              'Authorization': 'Bearer ' + this.token,
                        }
                     };
                     this.$axios
                     .get('/api/admin/attributes/delete_value?value_id=' + value_id, config)
                     .then(response => {
                        if(response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchAttribute();
                     })
                     .catch(error => {
                           if(error.response){
                              if(error.response.data.message){
                                 this.$swal("", error.response.data.message, "error");
                              } else {
                                 this.$swal("", "Something went wrong", "error");
                              }
                           } else {
                              this.$swal("", "Something went wrong", "error");
                           }
                           
                     });
					}
					
				});
      },
   }   
}
</script>